import { defineStore } from "pinia";

export type FilterStatusKeys = "new" | "my" | "in_progress" | "done";
export type FilterSectionKeys = "section";
export type FilterStoreKeys = "store";
export type FilterKeys = FilterStatusKeys | FilterSectionKeys | FilterStoreKeys;

export type Filter = {
  key: FilterKeys;
  type: "boolean" | "array";
  value: boolean | string[];
  active: boolean;
};

type OrderListFiltersState = {
  new: {
    key: "new";
    type: "boolean";
    value: boolean;
    active: boolean;
  };
  my: {
    key: "my";
    type: "boolean";
    value: boolean;
    active: boolean;
  };
  in_progress: {
    key: "in_progress";
    type: "boolean";
    value: boolean;
    active: boolean;
  };
  done: {
    key: "done";
    type: "boolean";
    value: boolean;
    active: boolean;
  };
  section: {
    key: "section";
    type: "array";
    value: string[];
    active: boolean;
  };
  store: {
    key: "store";
    type: "array";
    value: string[];
    active: boolean;
  };
};

const STATUS_KEYS = ["new", "my", "in_progress", "done"];
const stateDefault: OrderListFiltersState = {
  new: {
    key: "new",
    type: "boolean",
    value: false,
    active: false,
  },
  my: {
    key: "my",
    type: "boolean",
    value: true,
    active: true,
  },
  in_progress: {
    key: "in_progress",
    type: "boolean",
    value: false,
    active: false,
  },
  done: {
    key: "done",
    type: "boolean",
    value: false,
    active: false,
  },
  section: {
    key: "section",
    type: "array",
    value: [],
    active: false,
  },
  store: {
    key: "store",
    type: "array",
    value: [],
    active: false,
  },
};

export const useOrderListFiltersStore = defineStore("order_list_filters", {
  state: () => stateDefault,
  actions: {
    reset_status() {
      STATUS_KEYS.forEach((key) => {
        this[key].value = false;
        this[key].active = false;
      });
    },
    update_status(name: keyof OrderListFiltersState, value: boolean) {
      this.reset_status();

      this[name].value = value;
      this[name].active = value;
    },
    update_section(value: string[]) {
      this.section.value = value;
      this.section.active = value.length > 0;
    },
    update_store(value: string[]) {
      this.store.value = value;
      this.store.active = value.length > 0;
    },
    sectionIsSelected(name: string) {
      return this.section.value.some((section) => section.toLowerCase() === name.toLowerCase());
    },
  },
  getters: {
    status_list: (state) => [state.new, state.my, state.in_progress, state.done],
    count: (state) => {
      return ["section", "store"].reduce((acc, key) => (acc + state[key].value.length > 0 ? 1 : 0), 0);
    },
    // TODO: это лишнее - в функцию фильтрации надо передавать фильтры
    active_status_key: (state) => {
      const activeKey = Object.keys(stateDefault).find((key) => state[key].type === "boolean" && state[key].active);

      return activeKey ?? null;
    },
    section_exist: (state) => state.section.value.length > 0,
  },
});
